import React from "react";
import Seema from "../Assets/Common/seema-face.svg";
import SeemaHand from "../Assets/Common/seema-hand.svg";
import Clock from "../Assets/Common/clock.svg";
import Man from "../Assets/Common/man.svg";

interface SeemaMenCountProps {
  textComponent: React.ReactNode;
  menCount: number;
}

const SeemaMenCount: React.FC<SeemaMenCountProps> = ({
  textComponent,
  menCount,
}) => {
  return (
    <div className="seema-men-count-container">
      <div className="text-container">
        <img src={Seema} alt="seema" className="seema-face" />
        <img src={SeemaHand} alt="seema hand" className="seema-hand" />
        {textComponent}
      </div>
      <div className="illustration-container">
        <div className="men-container">
          {Array.from({ length: menCount }).map((_, index) => (
            <img
              src={Man}
              alt="man"
              className={`illustration men-item-${index + 1}`}
              key={index}
            />
          ))}
        </div>
        <img src={Clock} alt="clock" className="clock" />
      </div>
    </div>
  );
};

export default SeemaMenCount;
